// eslint-disable-next-line no-unused-vars
export default function ({ $gtm, route }) {
  $gtm.init("GTM-XXXXXXXX");
}
